import getShortPitchName from './get-short-pitch-name.ts'
// eslint-disable-next-line import/extensions
import { getPitchName } from './pitch-names.js'

type Opts = {
    showFull?: boolean
}

const defaultOpts = {
    showFull: false,
}

export default function formatPitchLabel(pitchType: string, opts: Opts = {}) {
    const options = { ...defaultOpts, ...opts }

    if (!pitchType) {
        return ''
    }

    const shortName = getShortPitchName(pitchType)
    const fullName = getPitchName(pitchType)
    const name = options.showFull ? fullName : shortName

    const labelClassSuffix = options.showFull ? 'full' : 'short'

    return `
        <span class="search-pitch-label search-pitch-label-${pitchType} search-pitch-label-${labelClassSuffix}" title="${fullName}">
            ${name}
        </span>
        `
}
